import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatSnackBar, MatDialogRef } from '@angular/material';
import { NavigationExtras, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { LeadService } from '../lead.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-viewlead',
  templateUrl: './viewlead.component.html',
  styleUrls: ['./viewlead.component.css']
})

export class ViewleadComponent implements OnInit {
  public leadDeatil: any;
  leadDetail: any;
  leadFields: any = {
    RawHeader: [],
    Dialers: []
  }

  public health:string ='Health category';
  CampIds: any = []
  dialerlist: any = []
  LeadId: number = 0

  dialer_data: any = {
    agents: "",
    disposition: "",
    lead_script: ""
  }

  IsLoaded: boolean = false
  heaalthInfo: any;
  hdata: any = [];

  public displayedColumns: string[];
  public newdata: any = [];
  public dataSource: any;
  public myDataArray: any = [];

  public tobacco: any;
  public hcat: any;
  public Opt: any = [];
  public opt2: any;
  currcampflag: any;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public dialogRef: MatDialogRef<ViewleadComponent>, protected router: Router, protected msg: MatSnackBar, protected fb: FormBuilder, private leadservice: LeadService) {
    console.log(data);
    this.displayedColumns = ["company_name", "issue_ages", "under_writing", "client_phi", "fax_no", "email", "require_eo"]
  }

  ngOnInit() {

    this.leadDetail = this.data.edit;

    //get Search_result in Leads healthInsurance
    this.leadservice.getSearchInsuranceResult(this.data.edit.id).subscribe((res: any) => {
      console.log("search respoce:", res);
      this.newdata = JSON.parse(res[0].search_result);
      // this.newdata = this.newdata;
      console.log("search ", this.newdata);
      this.dataSource = this.newdata
    }, error => {
      this.dataSource = []
    });


    this.CampIds = typeof this.leadDetail.id_dialer != 'undefined' && this.leadDetail.id_dialer ? this.leadDetail.id_dialer.split(",") : []

    this.CampIds = this.CampIds.filter((item: any, index: any) => {
      return this.CampIds.indexOf(item) == index
    }).sort()

    this.LeadId = typeof this.leadDetail.id != 'undefined' && this.leadDetail.id ? this.leadDetail.id : 0

    // @dialer mapping
    if (sessionStorage.getItem("allcampaign")) {
      this.dialerlist = JSON.parse(sessionStorage.getItem("allcampaign"))

      // It will filter with avilable dialers
      let CampIds: any = []
      this.CampIds.forEach((ele: any) => {
        let I: any = this.dialerlist.findIndex((ele2: any) => {
          return ele2.id == ele
        })
        if (I > -1)
          CampIds.push(ele)
      })
      this.CampIds = CampIds
    }

    /// get VM lead health info
    let lead_id = this.LeadId;
    this.leadservice.getHealthData(lead_id).subscribe((res: any) => {
      console.log(res)
      
      let Hlinfo = JSON.parse(res[0].search_filter)
      console.log(Hlinfo)
      console.log(Hlinfo.tobacco_categories)
      this.tobacco = Hlinfo.tobacco_categories
      // console.log(Object.keys(Hlinfo.health_category));
      // console.log(Object.values(Hlinfo.health_category));

      //health data display in lead
      Object.entries(Hlinfo.health_category).forEach((ele: any, i: any) => {
        Object.entries(ele[1]).forEach((ele1: any, i: any) => {
          console.log(ele1,"seees");
          console.log(ele,"seees");          
          this.Opt.push({health : ele[0], value :ele1[0], age : ele1[1][0]})
          
        })
      })
      //data health filter
      // console.log(Hlinfo.optional_filters)
      this.hcat = Hlinfo.optional_filters

    


      this.leadservice.gethealthinfo(JSON.stringify(Hlinfo)).subscribe((res => {
        console.log("gethealthinfo-", res)
        // console.log(Hlinfo)
        this.tobacco = res[0][0].category_name
        this.hcat = res[3]
        this.Opt = res[1]
        this.opt2 = res[2]
        
        console.log(this.tobacco)
      }))


      //  delete Hlinfo['id'];
      //  delete Hlinfo['iduser'];
      //  delete Hlinfo['lead_type'];
      //  delete Hlinfo['id_upload'];
      //  delete Hlinfo['pdf'];
      //  let dat = Object.entries(Hlinfo).forEach(([key, value]) =>{
      //   console.log(key, value)
      //   this.hdata.push({'key':key,'value':value})
      //  })
    })


    // @loading the lead's fields
    this.leadservice.GetLeadFields(this.CampIds.join()).subscribe(res => {
      console.log("res", res)
      this.leadFields = res || {
        RawHeader: [],
        Dialers: []
      }

      this.leadFields.RawHeader.forEach(ele => {
        ele['value'] = ""
        for (const [key, value] of Object.entries(this.leadDetail)) {
          if (key == ele.fields) {
            ele.value = value
            break
          }
        }
      })


      // It will load single lead's data
      this.leadservice.GetSingleLeadData(this.LeadId.toString()).subscribe(res => {
        console.log("res::", res)
        let lead_data: any = res.data

        // It will map lead's data on every dialers
        this.leadFields.Dialers.forEach((ele: any) => {
          ele['dialer_data'] = this.dialer_data
          ele['dialer'] = ""

          let I1: any = this.dialerlist.findIndex((ele2: any) => {
            return ele2.id == ele.id_dialer
          })
          console.log("I1::", I1)
          if (I1 > -1)
            ele.dialer = this.dialerlist[I1].name

          let I: any = lead_data.custom_fields.findIndex((ele3: any) => {
            return ele3.id_dialer == ele.id_dialer
          })

          if (I > -1) {
            ele.header.forEach((ele2: any) => {
              ele2['value'] = ""
              for (const [key, value] of Object.entries(lead_data.custom_fields[I])) {
                if (key == ele2.fields) {
                  ele2.value = value
                  break
                }
              }
            })
            ele.dialer_data = typeof lead_data.dialer_data[I] != 'undefined' && lead_data.dialer_data[I] ? lead_data.dialer_data[I] : this.dialer_data
          }
          else
            ele.header.forEach((ele2: any) => {
              ele2['value'] = ""
            })
        })
        console.log("this.leadFields::", this.leadFields)

        this.IsLoaded = true
      }, err => {
        console.log("err::", err)
        this.IsLoaded = true
      })
    }, err => {
      this.leadFields = {}
      console.log("err::", err)
      this.IsLoaded = true
    })
  }

  Close() {
    this.dialogRef.close();
    console.log("Dialog was Close");
  }

  CallNow(leadid: any, campaignid: any) {
    console.log(campaignid)
   /*  let campaign = campaignid.split(',');
    this.dialerlist.find((item: any) => {
      if (item.id == parseInt(campaign))
        this.currcampflag = item.dialer_type
    })
    console.log(this.currcampflag); */

    // console.log(campaign[0]);
    /* sessionStorage.setItem('currcampflag', this.currcampflag.toString());
    sessionStorage.setItem('currcampaign', campaign[0].toString()); */
    sessionStorage.setItem("loadlead", leadid.toString());
    /* let navigationExtras: NavigationExtras = {
      queryParams: {
        D1: campaign[0],
        L1:leadid
        // D1: btoa(campaign[0]),
        // L1:btoa(leadid)
      }
    }; */
    this.router.navigate(['/crm'])
      .then(() => {
        location.reload(true);
      })
    this.dialogRef.close();
  }

  /* insuranceSearch(leadid: any, id_dialer: any) {
    console.log("searchInsurance", leadid);
    this.data.id = leadid;
    this.leadservice.Searchinsurance(this.data).subscribe(res => {
      console.log("insuranceData", res);
    })
    let vm_session: any = sessionStorage.getItem("vm_session")
    if (sessionStorage.getItem("vm_session")) {
      window.open(environment.VM_ACCESS + "?vm_session=" + vm_session + "&leadid=" + leadid, "_blank")
    } else {
      alert("You must have VM account\nTo search the insurance!")
    }
  } */

}